import React from "react";
import { useSelector } from "react-redux";

import useDispensariesLink from "hooks/useDispensariesLink";
import { useEventTracker } from "hooks/useEventTracker";
import { getDomainCountryCode } from "redux/selectors/config";
import { Action, Category } from "utils/trackEvent";

export const HeaderLinks = () => {
  const countryCode = useSelector(getDomainCountryCode);

  const { publishEvent } = useEventTracker();

  const trackLinkClick = (eventLabel: string) => {
    publishEvent({
      action: Action.click,
      category: Category.header,
      label: eventLabel,
    });
  };

  const linkClasses = `mr-md mt-md font-bold whitespace-nowrap hover:underline`;

  return (
    <>
      <nav
        className="header__links hidden lg:flex overflow-x-auto whitespace-nowrap transition-[height] motion-reduce:transition-none"
        id="global-header-nav-links"
        aria-label="Popular pages"
      >
        <a
          className={linkClasses}
          data-testid="delivery"
          href="/delivery"
          onClick={() => {
            trackLinkClick("delivery");
          }}
        >
          Delivery
        </a>

        <a
          className={linkClasses}
          data-testid="dispensaries"
          href={useDispensariesLink({})}
          onClick={() => {
            trackLinkClick("dispensaries");
          }}
        >
          {countryCode === "CA" ? "Stores" : "Dispensaries"}
        </a>

        <a
          className={linkClasses}
          data-testid="deals"
          href="/deals"
          onClick={() => {
            trackLinkClick("deals");
          }}
        >
          Deals
        </a>

        <a
          className={linkClasses}
          data-testid="strains"
          href="/strains/lists"
          onClick={() => {
            trackLinkClick("strains");
          }}
        >
          Strains
        </a>

        <a
          className={linkClasses}
          data-testid="brands"
          href="/brands"
          onClick={() => {
            trackLinkClick("brands");
          }}
        >
          Brands
        </a>

        <a
          className={linkClasses}
          data-testid="products"
          href="/products"
          onClick={() => {
            trackLinkClick("products");
          }}
        >
          Products
        </a>

        {countryCode !== "CA" && (
          <a
            className={linkClasses}
            data-testid="cbd"
            href="/products/hemp-cbd"
            onClick={() => {
              trackLinkClick("cbd");
            }}
          >
            CBD
          </a>
        )}

        <a
          className={linkClasses}
          data-testid="doctors"
          href={"/medical-marijuana-doctors"}
          onClick={() => {
            trackLinkClick("doctors");
          }}
        >
          Doctors
        </a>

        <a
          className={linkClasses}
          data-testid="cannabis-101"
          href="/news/cannabis-101"
          onClick={() => {
            trackLinkClick("cannabis 101");
          }}
        >
          Cannabis 101
        </a>

        <a
          className={linkClasses}
          data-testid="social-impact"
          href="/social-impact"
          onClick={() => {
            trackLinkClick("social impact");
          }}
        >
          Social impact
        </a>
      </nav>
      <style jsx>{`
        .header__links {
          scrollbar-width: none; /* Firefox */
        }
        .header__links::-webkit-scrollbar {
          display: none;
        }
        @media (max-width: 767px) {
          #global-header-nav-links {
            /* Warning: This value needs to be updated when the size of the input changes! */
            height: 40px;
          }
        }
      `}</style>
    </>
  );
};
